<template>
  <div class="reconciliation-center">
    <div class="today-sum">
      <div :style="'background:'+ item.background +';'" class="today-sum-item" v-for="(item, index) in todaySum" :key="index">
        <div class="item-icon">
          <img :src="item.icon">
        </div>
        <div class="item-content">
          <p class="title">{{item.title}}
            <el-tooltip content="（昨日交易总额-昨日退款订单总额）*（100%-服务费百分比）-昨日门店补贴总额" placement="bottom" effect="light">
              <i v-if="index == 1" class="tipsA el-icon-question"></i>
            </el-tooltip>
          </p>
          <p class="amount">{{item.amount}} <span class="tips">元</span></p>
        </div>
      </div>
    </div>
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="finance-div">
      <div v-for="(item, index) in financeData" :key="index" :class="index == 0 ?  'finance first' : 'finance'">
        <div class="dataItem" v-for="(dataItem, itemIndex) in item.itemArr" :key="itemIndex">
          <img :src="dataItem.icon" class="dataItem-img">
          <div class="dataItem-content">
            <p class="dataItem-title">{{dataItem.title}}
              <el-tooltip content="订单金额-服务费-租金扣点-门店补贴金额" placement="bottom" effect="light">
                <i v-if="dataItem.key == 'totalIncomeAmount'" class="tipsB el-icon-question"></i>
              </el-tooltip>
            </p>
            <p class="dataItem-value">{{dataItem.amount}}</p>
          </div>
          <el-divider v-if="(item.itemArr.length - 1) != itemIndex" direction="vertical"></el-divider>
        </div>
      </div>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template v-for="(item, index) in tableThData" v-slot:[item.prop]="scope">
        <span v-if="item.prop != 'storeName' && item.prop != 'operation'" :key="index">{{ scope.row[item.prop] == 0 ? '0' : scope.row[item.prop]}}</span>
        <auth-button v-if="item.prop == 'storeName'" :key="index" auth="finance:store:detail" :elseInfo="scope.row.storeName">
          <el-button @click="lookDetaile(scope.row, 'baseInfo')" type="text" >{{scope.row.storeName}}</el-button >
        </auth-button>
        <auth-button auth="finance:store:detail" v-if="item.prop == 'operation'" :key="index" >
          <el-button type="text" @click="lookDetaile(scope.row, 'reconciliationInfo')">查看详情</el-button >
        </auth-button>
      </template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import { api_getStatementTradeSummaryPage, api_postReconciliationExport, api_postTradeStatisticsExport } from '@/api/finance'
import { downFile } from "@/utils";
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "rCenter",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      exportLoading: false,
      renderData: [
        {
          label: "选择日期",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
        },
        {
          label: "店铺名称",
          type: "choose-store",
          key: "storeId",
        },
        {
          label: "商场名称",
          placeholder: '请选择商场名称',
          type: "mall",
          key: "mallId",
        }
      ],
      form: {
        username: "",
        name: "",
      },
      tableThData: [
        { prop: "storeName", label: "店铺名称", minWidth: "150", },
        { prop: "storeRefId", label: "主体名称", minWidth: "130", },
        { prop: "mallName", label: "交易订单总数（笔）", minWidth: "150", },
        { prop: "nickname", label: "净交易总额（元）", minWidth: "150", },
        { prop: "refundTime", label: "退款总额（元）", minWidth: "150", },
        { prop: "paymentOrderId", label: "交易手续费（元）", minWidth: "180", },
        { prop: "totalRentDeductionAmount", label: "租金扣点（元）", minWidth: "120", },
        { prop: "transactionType", label: "应结算金额（元）", minWidth: "150", },
        { prop: "operation", label: "操作", minWidth: "100", },
      ],
      todaySum: [
        {
          title: '今日交易总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/today_sum0.png"),
          background: 'rgba(233, 236, 255, .5)',
          key: 'todayDealAmount'
        },
        {
          title: '今日结算总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/today_sum1.png"),
          background: 'rgba(255, 247, 220, .5)',
          key: 'todayIncomeAmount'
        }
      ],
      financeData: [{
        itemArr: [{
          title: '成交订单总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_7.png"),
          company: '元',
          key: 'totalDealAmount'
        },{
          title: '退款订单总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_3.png"),
          company: '元',
          key: 'totalRefundAmount'
        },{
          title: '净成交总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_1.png"),
          company: '元',
          key: 'totalRetainedDealAmount'
        },{
          title: '应实收总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_8.png"),
          company: '元',
          key: 'totalIncomeAmount'
        },{
          title: '交易手续费总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_9.png"),
          company: '元',
          key: 'totalCommissionAmount'
        },{
          title: '支付宝交易总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_20.png"),
          company: '元',
          key: 'totalAlipayAmount'
        },{
          title: '微信交易总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_19.png"),
          company: '元',
          key: 'totalWechatAmount'
        }]
      },{
        itemArr: [{
          title: '租金扣点总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_4.png"),
          company: '元',
          key: 'totalRentDeductionAmount'
        },{
          title: '订单交易总数（笔）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_2.png"),
          company: '笔',
          key: 'totalDealCount'
        },{
          title: '退款订单总数（笔）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_3.png"),
          company: '笔',
          key: 'totalRefundCount'
        },{
          title: '净成交总数（笔）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_10.png"),
          company: '笔',
          key: 'retainedDealCount'
        },{
          title: '优惠总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_11.png"),
          company: '元',
          key: 'totalDiscountAmount'
        },{
          title: '储值卡交易总额（元）',
          amount: '-',
          icon: require("@/assets/finance_images/finance_21.png"),
          company: '元',
          key: 'totalStoredCardAmount'
        }]
      }]
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.created && newParams.created.length > 0){
        newParams.startTime = +new Date(newParams.created[0])
        newParams.endTime = +new Date(newParams.created[1])
      }
      delete newParams.created
      const data = await api_getStatementTradeSummaryPage(newParams)
      this.todaySum.forEach((item)=> {
        item.amount = data.todayStatistics[item.key]
      })
      this.financeData.forEach((item)=> {
        item.itemArr.forEach((v,vd) => {
          v.amount = data.tradeStatistics[v.key]
          if(Number(v.amount) % 1 == 0){
            if(vd == 5 || vd == 6){
            v.amount = `${v.amount}.00`
          }
        }
        })
      })
      data.columnList = data.columnList || []
      this.tableThData = data.columnList.map((item) => {
        return {
          prop: item.valueKey,
          label: item.displayName,
          minWidth: 150
        }
      })
      this.tableThData.push({
        prop: 'operation',
        label: '操作',
        minWidth: 100
      })
      this.tableTrData = data.pageResult.list || []
      // 接口返回的字段名不一致，处理一下
      this.tableTrData.forEach(item =>{
        item.totalAliPayAmount = item.totalAlipayAmount
      })
      this.total = data.pageResult.count
      this.loading = false
    },
    lookDetaile (row, tab) {
      this.$router.push({
        path: `/financeShop/index/detail?id=${row.storeId}&tab=${tab}`
      })
    },

    // 点击导出
    async onExport() {
      this.exportLoading = true
      let params = {
        mallId: this.form.mallId || [],
        storeId: this.form.storeId || []
      }
      if(this.form.created && this.form.created.length > 0){
        params.startTime = +new Date(this.form.created[0])
        params.endTime = +new Date(this.form.created[1])
      }
      let res1 = await api_postReconciliationExport(params) // 交易明细 （列表）
      downFile(res1) // 导出交交易明细
      let res2 = await api_postTradeStatisticsExport(params) // 综合统计
      downFile(res2) // 导出综合统计
      this.exportLoading = false
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.reconciliation-center {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  ::v-deep{
    .search-box{
      margin-top: 20px;
    }
  }

  .el-button {
    min-width: 80px !important;
  }
  .today-sum{
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    .today-sum-item{
      height: 90px;
      width: calc(50% - 7.5px);
      display: flex;
      align-items: center;
      .item-icon{
        margin-left: 50px;
        margin-right: 20px;
        img{
          width: 46px;
          height: 46px;
        }
      }
      .item-content{
        p{
          margin: 0;
        }
        .title{
          font-size: 12px;
          color: #666666;
          margin-bottom: 15px;
        }
        .amount{
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .tips{
          font-size: 12px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
  }
  .finance{
    height: 100px;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    box-sizing: border-box;
    display: flex;
    min-width: 1650px;
  }
  .finance.first{
    border-top: 0;
    margin-bottom: 20px;
  }
  .finance-div{
    // min-width: 1160px;
    overflow: auto;
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #dcdfe6;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fafafa;
  }
  .dataItem{
    width: 230px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    img{
      width: 40px;
      height: 40px;
      margin-left: 20px;
    }
    .dataItem-content{
      margin-left: 10px;
      width: 154px;
      .dataItem-title{
        font-size: 12px;
        color: #666666;
        margin: 0;
        margin-bottom: 10px;
      }
      .dataItem-value{
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        margin: 0;
        span{
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          margin-left: 10px;
        }
      }
    }
    ::v-deep{
      .el-divider--vertical{
        height: 70px;
      }
    }
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .FINISHED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .DOING{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .REFUNDED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .CANCELED{
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }
  .tipsA{
    font-size: 13px;
    color: #FF8E12;
  }
  .tipsB{
    font-size: 13px;
    color: #999;
  }
  ::v-deep{
    .el-table__body-wrapper::-webkit-scrollbar{
      /*滚动条整体样式*/
      width: 4px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px !important;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #dcdfe6;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: #fafafa;
    }
    .el-table__fixed{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
    .el-table__fixed-right{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
  }
}
</style>
